/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { LocoStatusComponent } from './loco-status.component';
import { LocoStatusDataComponent } from './data/loco-status-data.component';
import { LocoStatusResolver } from './shared/loco-status.resolver';
import { NgModule } from '@angular/core';

const locoStatusRoutes: Routes = [
    {
        path: 'locomotive-status',
        component: LocoStatusComponent,
        data: { tab: 'Locomotive-Status' },
        resolve: {
            tabData: LocoStatusResolver
        },
        canDeactivate: [CanDeactivateViaEditGuardService],
        children: [
            {
                path: 'data',
                component: LocoStatusDataComponent,
                data: { tab: 'Locomotive-Status' },
                resolve: {
                    tabData: LocoStatusResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'data/:tabid',
                component: LocoStatusDataComponent,
                data: { tab: 'Locomotive-Status' },
                resolve: {
                    tabData: LocoStatusResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            }]
    }
];

/**
 * @export
 * @class LocoRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(locoStatusRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class LocoStatusRoutingModule {

}
